<ng-container *ngFor="let item of loopCounter()">
	<div class="list-view-loader">
		<div class="title">
			<app-square-skeleton width="80%" height="10px"></app-square-skeleton>
		</div>
		<div class="first-section-wrapper">
			<div class="gravatar">
				<app-line-skeleton [count]='1' width="80px" height="80px"></app-line-skeleton>
			</div>
			<div class="gravatar-title">
				<div>
					<app-square-skeleton width="90%" height="10px"></app-square-skeleton>
				</div>
				<div>
					<app-square-skeleton width="70%" height="10px"></app-square-skeleton>
				</div>
				<div>
					<app-square-skeleton width="30%" height="10px"></app-square-skeleton>
				</div>
			</div>
		</div>
		<div class="second-section-wrapper">
			<div class="wrapper">
				<app-square-skeleton width="80%" height="10px"></app-square-skeleton>
			</div>
			<div class="wrapper">
				<app-square-skeleton width="90%" height="10px"></app-square-skeleton>
			</div>
			<div class="wrapper">
				<app-square-skeleton width="60%" height="10px"></app-square-skeleton>
			</div>
		</div>
	</div>
</ng-container>